// ABOUTME: A person's round picture: their photo, or their initials on a soft background when there is none or
// ABOUTME: it does not load — a signed path can run out, and a deleted account has no photo at all.
import { useState } from "react"

interface CAvatarProps {
  /** The photo's full address; none — or one that fails to load — shows the initials. */
  src?: string | null
  /** Whose picture it is: the initials come from its first two words. */
  name: string
  /** Pixels, the same both ways. */
  size?: number
  className?: string
}

const initialsOf = (name: string) =>
  name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((word) => [...word][0]?.toUpperCase() ?? "")
    .join("")

/** Decorative: the name is always written next to it, so a screen reader skips the picture. */
export const CAvatar = ({ src, name, size = 32, className = "" }: CAvatarProps) => {
  // The address that failed, not a flag: a fresh address (the next day's signed path) is tried again.
  const [failedSrc, setFailedSrc] = useState<string | null>(null)
  const style = { width: size, height: size }

  if (src && src !== failedSrc) {
    return (
      <img
        src={src}
        alt=""
        style={style}
        className={`shrink-0 rounded-full object-cover ${className}`}
        onError={() => setFailedSrc(src)}
      />
    )
  }
  return (
    <span
      aria-hidden
      style={{ ...style, fontSize: Math.round(size * 0.4) }}
      className={`inline-flex shrink-0 items-center justify-center rounded-full bg-gray-200 font-semibold text-gray-600 ${className}`}
    >
      {initialsOf(name)}
    </span>
  )
}
